<template>
	<div class="wrapper">
		<div class="logout">
			<i class="el-icon-switch-button" style="font-size: 20px;cursor:pointer;" @click="signOut" v-if="isLogin"></i>
		</div>
		<div class="userInfo">
			<el-image style="width: 88px; height: 88px; border-radius: 50% " :src="userInfo.avatar || avatar"></el-image>
			<div class="name">Hi！{{ userInfo.nickName || '游客' }}</div>
			<div>
				<span class="text">基本信息</span>
				<i class="el-icon-edit" style="cursor:pointer;" v-if="isLogin" @click="goCenter"></i>
			</div>
		</div>
		<div class="noticeWrapper">
			<div class="title">
				<div>消息通知</div>
				<div class="more" @click="openMsgDrawer">更多</div>
			</div>
			<el-scrollbar class="noticeItem">
				<template v-if="noticeList.length">
					<div v-for="(item, index) in noticeList" :key="index" :style="{
          '--read': item.messageStatus == '2' ? '#297FFD' : '#F15151'
        }">
						<div class="noticeName">
							<span v-if="!(item.messageStatus == '2')" class="readTip">未读</span>
							<span>{{ item.name || '通知' }}</span>
						</div>
						<div class="noticeContent">
							<div class="contentText">{{ item.text }}</div>
							<div class="time">
								<span>{{ item.createTime }}</span>
								<span :style="{
                color: item.messageStatus == '2' ? '#999999' : '#297FFD',
                float: 'right',
                cursor: 'pointer'
              }"
								      @click="$refs.MessageDetail.init(item)"

								>去查看</span>
							</div>
						</div>
					</div>
				</template>

				<el-empty v-else description="暂无消息"></el-empty>
			</el-scrollbar>
		</div>
		<MessageDrawer ref="MessageDrawer" @read="getMessage" />
		<MessageDetail ref="MessageDetail" @read="getMessage" />
	</div>
</template>

<script>
import {signOut, getMqttUrl, getMessageByUserId} from '@/api/viewIndex';

const avatar = require('../../../assets/images/touxiang.png');
import localUrl from '@/axios/localUrl';
import {goLogin, judgeLogin} from '@/utils/judge';
import moment from 'moment';
import MessageDrawer from './MessageDrawer.vue';
import MessageDetail from './MessageDetail.vue';

export default {
	name: 'UserInfo',
	components: {MessageDrawer, MessageDetail},
	data() {
		return {
			noticeList: [],
			userInfo: {},
			avatar: avatar,
			isLogin: false,
			msgDetailVisible: false,
			client: null,
		};
	},
	mounted() {
		const token = sessionStorage.getItem('token_portalUI');
		if (token) {
			this.userInfo = JSON.parse(sessionStorage.getItem('userInfo_portalUI')) || {};
			this.isLogin = true;
			this.getMqttUrl();
			this.getMessage();
		}
	},
	beforeDestroy() {
		if (this.client) {
			this.client.end();
		}
	},
	methods: {
		signOut() {
			this.$msgbox({
				title: '提示',
				message: '确定退出登录吗？',
				showCancelButton: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {
						done();
					} else {
						done();
					}
				},
			})
					.then(() => {
						signOut()
								.then(async () => {
									await this.$store.dispatch('Logout');
									const origin = process.env.NODE_ENV === 'development'
											? 'https://auth-test.gczx.com:8443'
											: window.location.origin;
									// window.location.reload()
									window.location.href = origin + '/service/logout?redirect_uri=' + localUrl.redirectUrl;
								})
								.catch(err => {
									console.log('97 => err', err);
								});
					})
					.catch(() => {});
		},
		goCenter() {
			judgeLogin() ? this.$router.push('/userCenter') : goLogin();
			// this.$router.push('/userCenter')
		},
		getMqttUrl() {
			getMqttUrl().then(res => {
				const mqttUrl = res.data.result.mqttUrl;
				const userId = this.userInfo.userId;
				const random = Math.random().toString(16).substring(2);
				const topic = `msg/platform/${userId}/#`;
				const options = {
					connectTimeout: 40000,
					keepalive: 10,
					clientId: `pc-${userId}-${random}`,
					clean: true,
				};

				// this.$mqtt = mqtt.connect(mqttUrl, options);
				console.log('111 => res', res);
				const client = this.$mqtt.connect(mqttUrl, options);
				this.client = client;
				client.on('connect', () => {
					client.subscribe(topic, (err, res) => {
						if (!err) {
							// client.publish("presence", "Hello mqtt");
							console.log('subscribe', res);
						}
					});
				}).on('reconnect', (error) => {
					console.log('正在重连:', error);
				}).on('close', () => {
					console.log('连接已关闭');
				}).on('offline', () => {
					console.log('连接已断开');
				}).on('error', (error) => {
					console.log('连接错误:', error);
				}).on('end', () => {
					console.log('连接已结束');
				}).on('message', (topic, message) => {
					// message is Buffer
					console.log('收到mqtt', message.toString());
					if (!message.toString()) return;
					const info = JSON.parse(message.toString());
					this.$notify({
						title: '消息通知',
						message: info.text,
						type: 'success',
						duration: 5000,
						position: "bottom-right",
					});
					// client.end();
				});
			});
		},
		getMessage() {
			let data = {
				userId: this.userInfo.userId,
				pageNum: 1,
				pageSize: 10
			};
			getMessageByUserId(data).then(res => {
				console.log('111 => res', res);
				const {records = []} = res.data.result;
				this.noticeList = records.map(item => {
					return {
						...item,
						createTime: moment(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
					};
				});
			}).catch(err => {
				console.log(err);
			})
		},
		openMsgDrawer() {
			judgeLogin() ? this.$refs.MessageDrawer.init() : goLogin();
		},
	},
};
</script>

<style lang="scss" scoped>

.wrapper {
	height: 100%;
	position: relative;

	.logout {
		position: absolute;
		right: 18px;
		top: 18px;
	}

	.userInfo {
		height: 32%;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
		border-bottom: 1px solid #ebeef5;

		.name {
			color: #666666;
			margin: 20px 0;
		}

		.text {
			font-weight: 600;
			margin-right: 10px;
		}
	}

	.noticeWrapper {
		height: 68%;
		padding: 20px 25px 14px;
		color: #333333;

		.title {
			display: flex;
			justify-content: space-between;
			margin-bottom: 25px;

			.more {
				color: #999999;
				font-size: 14px;
				cursor: pointer;
			}
		}

		.noticeItem {
			font-size: 14px;
			height: calc(100% - 50px);
			overflow-y: auto;

			.noticeName {
				font-weight: 600;
				margin-bottom: 10px;

				.readTip {
					color: #ffffff;
					margin-right: 6px;
					display: inline-block;
					padding: 3px 6px;
					background-color: #F15151;
					font-size: 12px;
					border-radius: 4px;
					font-weight: normal;
				}

				&::before {
					content: '';
					display: inline-block;
					width: 8px;
					height: 8px;
					background: var(--read);
					border-radius: 50%;
					margin-right: 6px;
				}
			}

			.noticeContent {
				padding: 10px;
				background-color: #F7F7F7;
				margin-bottom: 10px;
				border-radius: 6px;
				color: #666666;

				.contentText {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					margin-bottom: 10px;
				}

				.time {
					font-size: 12px;
				}
			}
		}
	}
}


</style>
